module.exports = __webpack_public_path__ + "static/img/loading1.cbee0c4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/loading1.gif
// module id = lrj5
// module chunks = 15 16 18 21